import {
    FETCH_PARKED_START,
    FETCH_PARKED_SUCCESS,
    FETCH_PARKED_ERROR,
    SET_PARKED_FILTER,
    SET_PARKED_PAGINATION,
    VIEW_PARKED_VISIT_LOADING_START,
    VIEW_PARKED_VISIT_LOADING_END,
    RESET_PARKED_FILTER,
    SET_PARKED_AUTO_NEXT_VISIT
} from '../../actions/mrt/parkedAction';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    parked: [],
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "desc" }],
    skippedVisits: [],
    autoNextVisit: false,
};

const parkedReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_PARKED_START:
        case VIEW_PARKED_VISIT_LOADING_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_PARKED_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, parked: action.parked };
        }
        case FETCH_PARKED_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_PARKED_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }

        case SET_PARKED_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }


        case VIEW_PARKED_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }

        case RESET_PARKED_FILTER: {
            newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };

        }
        case SET_PARKED_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }

        default:
            return state;
    }
}

export default parkedReducer;
